import { MediaChannel } from "../dto/Brief";
import { BriefAllocatorDTO, BriefMediaChannelAllocator } from "../dto/BriefAllocator";
import { BriefJAMDTO, BriefMediaChannel } from "../dto/BriefJAM";


export function ConvertJamToAllocatorDTO (brief: BriefJAMDTO, inputData: any): BriefAllocatorDTO {
    return {
        SystemId: brief.SystemId,
        brief: {
            ...brief.brief,
            
            Advertiser: brief.brief.Advertiser.name,
            Agency: brief.brief.Agency?.name,
            Product: brief.brief.Product.name,
            Sector: brief.brief.Sector.name,
            Target: brief.brief.Target.name,

            MediaChannels: ConvertMediaChannels(brief.brief.MediaChannels, inputData),

            // Optional keys
            Country: brief.brief?.Country?.name,

            // Removed keys
            Digital: undefined,
        }
    } as BriefAllocatorDTO

}

function ConvertMediaChannels (channels: BriefMediaChannel[], inputData: any): BriefMediaChannelAllocator[] {

    return channels.map((channel: BriefMediaChannel) => {
        return {
            ...channel,
    
            Name: channel.Name.name,
            Code: inputData.selectedMediaChannels.find((item: MediaChannel) => item.id === channel.Name.id).code
        }
    })
}

// export function clearNullFields<T extends object> (data: T): T {
//     return JSON.parse(JSON.stringify(data), (_, v) => v ?? undefined)
// }